export const BASE_COLORS = [
  { backgroundColor: "#F5A623", textColor: "black", autoselectable: true },
  { backgroundColor: "#DF5F00", textColor: "white", autoselectable: true },
  { backgroundColor: "#CF1F0F", textColor: "white", autoselectable: true },
  { backgroundColor: "#139E60", textColor: "white", autoselectable: true },
  { backgroundColor: "#1D73BF", textColor: "white", autoselectable: true },
  { backgroundColor: "#621BB1", textColor: "white", autoselectable: true },
  { backgroundColor: "#6D6D6D", textColor: "white", autoselectable: false }
];
